import { string, object, mixed } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';
import { validateObjectId } from '@shared/utils';

import { TicketType } from 'v2/constants';

export const ticketFormSchema = object().shape({
  title: string().trim().required(YUP_ERRORS_MESSAGES.REQUIRED),
  subtitle: string().when('type', ([type], subtitleSchema) => {
    if (type === TicketType.CONTEST) {
      return subtitleSchema.required(YUP_ERRORS_MESSAGES.REQUIRED);
    } else {
      return subtitleSchema;
    }
  }),
  type: mixed().oneOf(Object.values(TicketType)).required(YUP_ERRORS_MESSAGES.REQUIRED),
  description: string().trim().required(YUP_ERRORS_MESSAGES.REQUIRED),
  date: mixed()
    .required(YUP_ERRORS_MESSAGES.REQUIRED)
    .test('is-future-date', YUP_ERRORS_MESSAGES.AFTER_NOW, (value) => new Date(value as string) > new Date()),
  backgroundImageId: string()
    .test({
      message: YUP_ERRORS_MESSAGES.OBJECT_ID,
      test: validateObjectId,
    })
    .when('type', ([type], backgroundImageIdSchema) => {
      if (type === TicketType.CONTEST) {
        return backgroundImageIdSchema.required(YUP_ERRORS_MESSAGES.REQUIRED);
      } else {
        return backgroundImageIdSchema.nullable();
      }
    }),
  link: string().trim().url(YUP_ERRORS_MESSAGES.VALID_LINK),
  details: string().nullable(),
});
